<template>
	<div class="input-wrapper">
		<div class="label__content">
			<div class="content-header">
				<TypographyKTypographyBody5
					class="label"
					:color="'var(--color_font_black_wite)'"
					font-type="semi-bold"
					>{{ label }}</TypographyKTypographyBody5
				>
				<div
					class="content-header__btn"
					@click="changeVisibleField"
				>
					{{ isVisibleInput ? 'Свернуть' : 'Развернуть' }}
				</div>
			</div>

			<UiTextArea
				v-if="isVisibleInput"
				v-model="modelValue"
				:placeholder="placeholder"
				:readonly="readonly"
				:height="height"
			>
				<template
					#left-icon
					v-if="$slots?.['left-icon']"
				>
					<slot name="left-icon" />
				</template>
			</UiTextArea>
			<div
				class="clear-value"
				v-if="isClearable && isVisibleInput"
				@click="clearValue"
			>
				очистить всё
			</div>
		</div>
		<UiButton
			:label="btnTitle || (modelValue ? 'Изменить' : '+ Добавить')"
			:size="ButtonSizeType.small"
			:color="ButtonType.primary"
			v-if="isNeedChangeBtn"
			class="btn"
			:is-spinner-loading="isLoading"
			:disabled="isDisabled"
			@click="clickHandler"
		/>
		<slot
			name="additional-content"
			v-if="$slots['additional-content']"
		/>
	</div>
</template>

<script setup lang="ts">
	import { ButtonSizeType, ButtonType } from '~~/shared/interfaces/ui';

	const emits = defineEmits(['clickBtn', 'chooseSuggestion']);
	const modelValue = defineModel('modelValue', { required: true, type: String });
	const props = withDefaults(
		defineProps<{
			readonly?: boolean;
			label?: string;
			isNeedChangeBtn?: boolean;
			isNeedAlwaysVisibleInput?: boolean;
			placeholder?: string;
			btnTitle?: string;
			isLoading?: boolean;
			isDisabled?: boolean;
			suggestions?: any;
			isVisibleSuggestionsDefault?: boolean;
			height?: string;
			isClearable?: boolean;
		}>(),
		{ height: '50px', isClearable: true, isNeedAlwaysVisibleInput: true }
	);

	const isVisibleInput = ref(props.isNeedAlwaysVisibleInput);

	const changeVisibleField = () => {
		console.log('changeVisibleField');
		isVisibleInput.value = !isVisibleInput.value;
	};

	const clearValue = () => {
		modelValue.value = '';
	};

	const clickHandler = () => {
		emits('clickBtn');
	};
</script>

<style scoped lang="scss">
	.input-wrapper {
		background-color: #eaedf5;
		padding: 10px;
		border-radius: 10px;

		.clear-value {
			position: relative;
			margin-left: auto;
			font-size: 12px;
			color: #757484;
			cursor: pointer;

			&:hover {
				&::after {
					content: '';
					width: 100%;
					position: absolute;
					left: 0px;
					bottom: -2px;
					border-bottom: 1px solid #757484;
				}
			}
		}

		.label__content {
			display: flex;
			flex-direction: column;
			gap: 5px;

			.content-header {
				display: flex;
				justify-content: space-between;
				width: 100%;

				&__btn {
					position: relative;
					font-size: 12px;
					color: #2e4a85;
					font-weight: 500;
					cursor: pointer;

					&:hover {
						&::after {
							content: '';
							width: 100%;
							position: absolute;
							left: 0px;
							bottom: -2px;
							border-bottom: 1px solid #2e4a85;
						}
					}
				}
			}
		}

		.btn {
			width: 100%;
			margin-top: 10px;
			min-height: 30px;
		}
	}
</style>
